import { TextArea } from '@/components/inputs/TextArea'
import { type ChangeEvent, useCallback } from 'react'
import { FormField } from '@/components/Form'

export interface TextQuestionAnswerEditorProps {
  value?: string
  onChange?: (value: string) => void
  isDisabled?: boolean
  isInvalid?: boolean
  onBlur?: () => unknown
  name?: string
  'aria-label'?: string
  'aria-labelledby'?: string
  'aria-describedby'?: string
  /**
   * Test ID attribute for the text area.
   */
  testId?: string
}

/**
 * Editor for text questions.
 */
export function TextQuestionAnswerEditor({
  value,
  onChange,
  isDisabled,
  onBlur,
  isInvalid,
  testId,
  ...rest
}: TextQuestionAnswerEditorProps) {
  const onTextAreaChange = useCallback(
    (e: ChangeEvent<HTMLTextAreaElement>) => onChange?.(e.target.value),
    [onChange],
  )

  const onTextAreaFocusChange = useCallback(
    (isFocused: boolean) => !isFocused && onBlur?.(),
    [onBlur],
  )

  return (
    <FormField>
      <TextArea
        value={value}
        onChange={onChange ? onTextAreaChange : undefined}
        disabled={isDisabled}
        invalid={isInvalid}
        placeholder="Enter your answer here..."
        rows={4}
        onFocusChange={onTextAreaFocusChange}
        testId={testId}
        {...rest}
      />
    </FormField>
  )
}
